import React from 'react';
import { useParams } from 'react-router-dom';
import './BlogPost.css';
import MessiImage from '../assets/images/Messi.jpg';

function BlogPost() {
  const { id } = useParams();
  
  // Datos de los artículos (en una app real esto vendría de una API)
  const blogPosts = {
    'asegura-tus-boletos-al-mundial-2026': {
      id: 1,
      title: "Asegura tus boletos al mundial 2026 antes de qué suban los precios — RTB Collect",
      excerpt: "El Mundial de la FIFA es el evento deportivo más esperado del planeta. Descubre por qué esperar para comprar boletos es la peor idea y cómo los RTB pueden ayudarte a asegurar tu entrada.",
      date: "20 Oct 2024",
      readTime: "8 min",
      category: "RTB",
      image: MessiImage,
      content: `
        <p>El Mundial de la FIFA es el evento deportivo más esperado del planeta. Millones de personas alrededor del mundo sueñan con estar presentes en los estadios y vivir la emoción de los partidos en vivo. Sin embargo, si hay algo que año tras año se repite, es el problema con los boletos del Mundial:</p>
        
        <ul>
          <li>Se agotan demasiado rápido.</li>
          <li>Los precios se disparan conforme se acerca la fecha.</li>
          <li>Y muchas veces, quienes esperan para comprarlos terminan pagando mucho más de lo necesario o, peor aún, quedándose sin entradas.</li>
        </ul>
        
        <p>Entonces, la pregunta es clara: ¿qué hacer para no perderte la oportunidad de vivir la experiencia FIFA?</p>
        
        <h2>El riesgo de esperar para comprar tus boletos del Mundial</h2>
        
        <p>Comprar boletos para el Mundial a última hora casi nunca es una buena idea. A medida que se acerca el torneo, la demanda crece y los precios suben. Además, la reventa hace que los costos se multipliquen, sin garantizarte seguridad en tu compra.</p>
        
        <p>En pocas palabras:</p>
        <ul>
          <li>Si compras tarde, pagarás mucho más.</li>
          <li>Si no alcanzas, te quedas fuera.</li>
        </ul>
        
        <h2>La alternativa: ¿Qué son los RTB (Right To Buy)?</h2>
        
        <p>Aquí es donde entra en juego una alternativa inteligente: los RTB (Right To Buy).</p>
        
        <p>Explicado de manera sencilla, un RTB es un derecho de compra anticipado que te asegura la posibilidad de adquirir tu boleto oficial para el Mundial a un precio mucho más accesible y sin la incertidumbre de la reventa.</p>
        
        <p>En lugar de esperar a que los boletos se agoten, con los RTB puedes:</p>
        <ul>
          <li>Asegurar tu entrada con anticipación.</li>
          <li>Evitar la especulación y los sobreprecios.</li>
          <li>Tener más control sobre tus gastos para el viaje al Mundial.</li>
        </ul>
        
        <h2>¿Cómo funcionan los RTB para los boletos del Mundial FIFA?</h2>
        
        <p>El funcionamiento es más simple de lo que parece:</p>
        <ol>
          <li>Adquieres un RTB (Right To Buy).</li>
          <li>Este te da el derecho de comprar un boleto oficial del Mundial cuando estén disponibles.</li>
          <li>Sigues los precios y oportunidades, asegurando que no pagarás de más.</li>
        </ol>
        
        <p>En lugar de luchar contra la incertidumbre o pagar costos exagerados, el RTB te ofrece una forma clara y transparente de planear tu viaje al Mundial.</p>
        
        <h2>Lleva el control de tus RTB con una sola herramienta</h2>
        
        <p>Para los verdaderos fanáticos que quieren asegurarse de estar en el Mundial, existe una plataforma que facilita todo este proceso: RTB Collect.</p>
        
        <p>En nuestro sitio podrás:</p>
        <ul>
          <li>Llevar un seguimiento de los precios de los RTB.</li>
          <li>Planear tu compra de boletos para el Mundial con seguridad.</li>
          <li>Mantenerte actualizado en todo momento para no perder tu oportunidad.</li>
        </ul>
        
        <h2>Conclusión</h2>
        
        <p>Si de verdad sueñas con vivir la experiencia del Mundial FIFA en persona, esperar para comprar tus boletos no es una opción. Los RTB son la alternativa más sencilla, segura y económica para garantizar tu entrada y disfrutar de cada partido sin preocupaciones.</p>
      `
    }
  };

  const post = blogPosts[id];

  if (!post) {
    return (
      <div className="blog-post">
        <div className="blog-post__not-found">
          <h1>Artículo no encontrado</h1>
          <p>El artículo que buscas no existe.</p>
          <a href="/blog" className="btn btn-primary">Volver al blog</a>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-post">
      <div className="blog-post__container">
        <div className="blog-post__header">
          <div className="blog-post__meta">
            <span className="badge badge-primary">{post.category}</span>
            <span className="blog-post__date">{post.date}</span>
            <span className="blog-post__read-time">{post.readTime} de lectura</span>
          </div>
          <h1 className="blog-post__title">{post.title}</h1>
          <p className="blog-post__excerpt">{post.excerpt}</p>
        </div>

        <div className="blog-post__image">
          <img src={post.image} alt={post.title} />
        </div>

        <div className="blog-post__content">
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
        </div>

        <div className="blog-post__footer">
          <a href="/blog" className="btn btn-secondary">← Volver al blog</a>
          <a href="/register" className="btn btn-primary">Comenzar a monitorear</a>
        </div>
      </div>
    </div>
  );
}

export default BlogPost;
